/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Toast_Delete_PdcInputs */

const vi_pll_toast_delete_pdc = /** @type {(inputs: Pll_Toast_Delete_PdcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xóa phiếu điều chuyển`)
};

/**

* @param {Pll_Toast_Delete_PdcInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_toast_delete_pdc = /** @type {((inputs?: Pll_Toast_Delete_PdcInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Toast_Delete_PdcInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_toast_delete_pdc(inputs)
});